(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["ct-reveal"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ct-reveal')) {
    customElements.define(
      'ct-reveal',
      class CtReveal extends HTMLElement {
        connectedCallback() {
          this.inner = this.querySelector('.ct-reveal__inner');
          this.nodes = Array.from(this.querySelectorAll('[data-reveal-node]'));
          this.progress = 0;
          if (!this.inner || !this.nodes.length) return;

          this.revealPoint = parseFloat(this.dataset.revealPoint) || 0.65;
          this.ticking = false;
          this.onScroll = this.onScroll.bind(this);
          this.measure = this.measure.bind(this);

          const editor = window.Shopify && Shopify.designMode;
          const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

          // Editor + reduced motion: show everything, skip scroll tracking so
          // merchants can edit every node and motion-sensitive users see it all.
          if (editor || reduced) {
            this.revealAll();
            if (editor) {
              window.addEventListener('resize', this.measure, { passive: true });
            }
            return;
          }

          // Switch on the hidden starting state only now that JS is driving it.
          this.classList.add('is-ready');
          this.measure();
          window.addEventListener('scroll', this.onScroll, { passive: true });
          window.addEventListener('resize', this.measure, { passive: true });
          this.onScroll();
        }

        disconnectedCallback() {
          window.removeEventListener('scroll', this.onScroll);
          window.removeEventListener('resize', this.measure);
        }

        measure() {
          const innerRect = this.inner.getBoundingClientRect();
          const h = innerRect.height || 1;
          // Each node's threshold = its dot centre as a 0–1 ratio down the rail.
          this.thresholds = this.nodes.map((node) => {
            const dot = node.querySelector('.ct-reveal__dot') || node;
            const r = dot.getBoundingClientRect();
            return Math.max(0, Math.min(1, (r.top - innerRect.top + r.height / 2) / h));
          });
          this.onScroll();
        }

        onScroll() {
          if (this.ticking) return;
          this.ticking = true;
          requestAnimationFrame(() => {
            const rect = this.inner.getBoundingClientRect();
            const vh = window.innerHeight || document.documentElement.clientHeight;
            const ref = vh * this.revealPoint;
            let p = (ref - rect.top) / (rect.height || 1);
            p = Math.max(0, Math.min(1, p));
            // Monotonic: the reveal only ever moves forward.
            if (p > this.progress) this.progress = p;
            this.apply(this.progress);
            this.ticking = false;
          });
        }

        apply(p) {
          this.style.setProperty('--ct-reveal-progress', p);
          if (!this.thresholds) return;
          this.nodes.forEach((node, i) => {
            if (p >= this.thresholds[i] - 0.001) {
              node.classList.add('is-revealed', 'is-reached');
            }
          });
        }

        revealAll() {
          this.style.setProperty('--ct-reveal-progress', 1);
          this.nodes.forEach((node) => node.classList.add('is-revealed', 'is-reached'));
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["ct-subscription"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ct-subscription')) {
    customElements.define(
      'ct-subscription',
      class CtSubscription extends HTMLElement {
        connectedCallback() {
          this.form = this.querySelector('form');

          // Every `selling_plan` input, including the hidden one used in
          // single-option mode — these are what get suppressed for a one-time
          // purchase. The radios are a subset, and drive the selected mode.
          this.planInputs = Array.from(this.querySelectorAll('input[name="selling_plan"]'));
          this.planRadios = this.planInputs.filter((i) => i.type === 'radio');
          this.hasHiddenPlan = this.planInputs.some((i) => i.type === 'hidden');

          // Classic layout: a separate text button that buys once.
          const oneTime = this.querySelector('[data-ct-onetime]');
          if (oneTime) oneTime.addEventListener('click', () => this.suppressPlans());

          // Stacked layout: the one-time card is a blank-valued radio in the
          // same group. Capture phase so the inputs are already disabled by the
          // time product-form-component's own submit handler reads the form.
          if (this.form) {
            this.form.addEventListener(
              'submit',
              () => {
                if (this.dataset.mode === 'onetime') this.suppressPlans();
              },
              true
            );
          }

          // "How does my subscription work?" modal.
          const how = this.querySelector('[data-ct-how-dialog]');
          if (how) {
            this.querySelectorAll('[data-ct-how-open]').forEach((b) => b.addEventListener('click', () => how.showModal()));
            how.querySelectorAll('[data-ct-how-close]').forEach((b) => b.addEventListener('click', () => how.close()));
            how.addEventListener('click', (e) => {
              if (e.target === how) how.close();
            });
          }

          this.addEventListener('change', (event) => {
            if (event.target && event.target.name === 'selling_plan') this.sync();
          });

          this.sync();
        }

        // Disable rather than remove, then restore on the next tick: the form
        // has already been serialised by then, and the radios stay clickable.
        suppressPlans() {
          this.planInputs.forEach((i) => (i.disabled = true));
          setTimeout(() => this.planInputs.forEach((i) => (i.disabled = false)), 0);
        }

        sync() {
          // Single-option mode has no radio to read, so fall back to the
          // hidden plan input, which carries the same data attributes.
          const active =
            this.planRadios.find((r) => r.checked) || this.planInputs.find((i) => i.type === 'hidden');
          const mode = active && active.value !== '' ? 'subscribe' : 'onetime';
          this.dataset.mode = mode;

          const label = this.querySelector('[data-ct-atc-label]');
          if (label) {
            const next = mode === 'onetime' ? this.dataset.labelOnetime : this.dataset.labelSubscribe;
            if (next) label.textContent = next;
          }

          const price = this.querySelector('[data-ct-atc-price]');
          if (price) {
            price.textContent = (mode === 'subscribe' && active && active.dataset.price) || '';
          }

          // Multi-month plans ship N units per delivery: keep the cart
          // quantity in step with the selection so the charge matches the
          // "$X × N = $total" the card promises. One-time always buys 1.
          // Supply plans post a different variant (the N-day supply kit) at
          // quantity 1 instead of N units of this product.
          const swap = (mode === 'subscribe' && active && active.dataset.variant) || '';
          const idInput = this.form && this.form.querySelector('input[name="id"]');
          if (idInput) {
            if (!idInput.dataset.ctBase) idInput.dataset.ctBase = idInput.value;
            idInput.value = swap || idInput.dataset.ctBase;
          }
          const qty = this.form && this.form.querySelector('input[name="quantity"]');
          if (qty) {
            const months = mode === 'subscribe' && active && parseInt(active.dataset.months || '1', 10);
            qty.value = !swap && months > 1 ? months : 1;
          }

          // Plan-scoped rows: `data-show-plan` holds a plan token, matched the
          // same way the Liquid side matches them — against the plan's id +
          // name + option values (`data-hay` on the plan input). No plan
          // selected (one-time) hides every plan-scoped row.
          const hay = (mode === 'subscribe' && active && active.dataset.hay) || '';
          this.querySelectorAll('[data-show-plan]').forEach((el) => {
            const tok = (el.dataset.showPlan || '').toLowerCase();
            const on = tok !== '' && hay.toLowerCase().includes(tok);
            el.toggleAttribute('data-plan-off', !on);
          });
          this.dataset.planReady = '1';
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["ct-timeline"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ct-timeline')) {
    customElements.define(
      'ct-timeline',
      class CtTimeline extends HTMLElement {
        connectedCallback() {
          this.bar = this.querySelector('.ct-timeline__bar');
          this.steps = Array.from(this.querySelectorAll('.ct-timeline__step'));
          if (!this.bar || !this.steps.length) return;

          this.startRatio = parseFloat(this.dataset.fillStart) || 0.85;
          this.endRatio = parseFloat(this.dataset.fillEnd) || 0.4;
          this.ticking = false;
          this.onScroll = this.onScroll.bind(this);
          this.measure = this.measure.bind(this);

          this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          if (this.reduced) {
            this.apply(1);
            return;
          }

          this.measure();
          window.addEventListener('scroll', this.onScroll, { passive: true });
          window.addEventListener('resize', this.measure, { passive: true });
          this.onScroll();

          // Theme editor: hold a step "reached" when the merchant selects it.
          if (window.Shopify && Shopify.designMode) {
            this.addEventListener('shopify:block:select', () => {
              this.measure();
              this.onScroll();
            });
          }
        }

        disconnectedCallback() {
          window.removeEventListener('scroll', this.onScroll);
          window.removeEventListener('resize', this.measure);
        }

        get vertical() {
          return window.matchMedia('(max-width: 749px)').matches;
        }

        measure() {
          const barRect = this.bar.getBoundingClientRect();

          // Position the line through the pill row's centre (desktop only;
          // mobile uses a full-height vertical line so no offset needed).
          const firstPill = this.steps[0] && this.steps[0].querySelector('.ct-timeline__pill');
          if (firstPill && !this.vertical) {
            const pr = firstPill.getBoundingClientRect();
            const center = pr.top - barRect.top + pr.height / 2 - 1;
            this.bar.style.setProperty('--ct-tl-line-top', center + 'px');
          }

          // Each step's "reached" threshold = its pill centre as a 0–1 ratio
          // along the fill axis.
          const span = this.vertical ? barRect.height : barRect.width || 1;
          this.thresholds = this.steps.map((step) => {
            const pill = step.querySelector('.ct-timeline__pill');
            const target = pill || step;
            const r = target.getBoundingClientRect();
            const offset = this.vertical
              ? r.top - barRect.top + r.height / 2
              : r.left - barRect.left + r.width / 2;
            return Math.max(0, Math.min(1, offset / span));
          });
          this.onScroll();
        }

        onScroll() {
          if (this.ticking) return;
          this.ticking = true;
          requestAnimationFrame(() => {
            const rect = this.bar.getBoundingClientRect();
            const vh = window.innerHeight || document.documentElement.clientHeight;
            const start = vh * this.startRatio;
            const end = vh * this.endRatio;
            const edge = this.vertical ? rect.top : rect.top;
            let p = (start - edge) / (start - end || 1);
            p = Math.max(0, Math.min(1, p));
            this.apply(p);
            this.ticking = false;
          });
        }

        apply(p) {
          this.style.setProperty('--ct-tl-progress', p);
          const thresholds = this.thresholds;
          this.steps.forEach((step, i) => {
            const reached = thresholds ? p >= thresholds[i] - 0.001 : true;
            step.classList.toggle('is-reached', reached);
          });
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
